(function () {
  const outingRoundsFormApp = function () {
    const toggleTeamOnlyFields = () => {
      const format = $('[name$="[round_format]"]').val();
      $('.round-team-only').toggleClass('d-none', format !== 'team');
    };

    const bindFormatChange = () => {
      $(document).on('change', '[name$="[round_format]"]', toggleTeamOnlyFields);
    };

    $(document).on('turbolinks:load', () => {
      const onRoundsPage =
        $('body').hasClass('controller-outings-rounds') ||
        $('body').hasClass('controller-outings-round_settings');
      if (!onRoundsPage) return;

      bindFormatChange();
    });
  };

  if (typeof window !== 'undefined') {
    window.outingRoundsFormApp = outingRoundsFormApp();
  }
})();
